import { lazy, Suspense } from 'react';
import { useFeedbackModalStore } from './store';

// 懒加载 FeedbackModal，减少首屏包体积
const FeedbackModal = lazy(() => import('./modal').then(module => ({ default: module.FeedbackModal })));

/**
 * 全局反馈弹窗容器
 * 在应用根组件中使用
 */
export default function FeedbackModalLoadable() {
  const visible = useFeedbackModalStore(state => state.visible);

  // 只在需要显示时才加载组件
  if (!visible) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <FeedbackModal />
    </Suspense>
  );
}

export { closeFeedbackModal, openFeedbackModal } from './helper';
